import React from 'react';
import { ReactComponent as NavLogo } from '../../home-redesign/assets/nav-logo.svg';

export type ComparisonRow = {
  label: string;
  google: string;
  chisme: string;
};

interface PartnersComparisonTableProps {
  rows: readonly ComparisonRow[];
  competitorLabel?: string;
}

const divideClass = 'divide-[rgba(74,33,71,0.12)]';
const chismeCellClass = 'bg-[#fefcfd] p-4 font-jakarta sm:p-5';

const PartnersComparisonTable: React.FC<PartnersComparisonTableProps> = ({
  rows,
  competitorLabel = 'Google / Meta',
}) => (
  <div className="overflow-hidden rounded-[24px] border border-[rgba(74,33,71,0.12)] bg-white">
    <div className={`divide-y ${divideClass}`}>
      <div className={`grid grid-cols-3 divide-x ${divideClass} font-jakarta text-sm font-semibold sm:text-base`}>
        <div className="p-4 sm:p-5" />
        <div className="p-4 text-center text-[#2a0f2a] sm:p-5">{competitorLabel}</div>
        <div className={`${chismeCellClass} flex items-center justify-center`}>
          <NavLogo aria-hidden className="h-5 w-[64px] text-chisme-primary sm:h-6 sm:w-[76px]" />
        </div>
      </div>

      {rows.map((row) => (
        <div key={row.label} className={`grid grid-cols-3 divide-x ${divideClass}`}>
          <div className="p-4 font-jakarta text-sm font-semibold text-[#2a0f2a] sm:p-5 sm:text-base">
            {row.label}
          </div>
          <div className="p-4 font-jakarta text-sm text-[#2a0f2a] sm:p-5">{row.google}</div>
          <div className={`${chismeCellClass} text-sm font-medium text-[#2a0f2a]`}>
            {row.chisme}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PartnersComparisonTable;
